import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Thread } from '../message-center.model';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MessageCenterService } from '@k12/messaging';
import { MsalService } from '@azure/msal-angular';
import { MatButtonModule } from '@angular/material/button';
import { isSameAccountToken, normalizeAccountToken } from '@k12/app-services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-message-center-chat-header, [chat-header]',
  imports: [MatIconModule, MatMenuTrigger, MatMenuModule, MatButtonModule],
  templateUrl: './message-center-chat-header.component.html',
  styleUrl: './message-center-chat-header.component.scss'
})
export class MessageCenterChatHeaderComponent {
  private readonly messageService: MessageCenterService = inject(MessageCenterService);
  private readonly msalService: MsalService = inject(MsalService);
  private readonly accountId?: string = '';
  private readonly accountToken: string = '';

  @Input() thread: Thread | null = null;

  @Output() archiveThread = new EventEmitter<Thread>();
  @Output() markThreadAsUnread = new EventEmitter<Thread>();

  constructor() {
    this.accountId = this.msalService.instance.getActiveAccount()?.localAccountId;
    if (this.accountId) {
      this.accountToken = normalizeAccountToken(this.accountId);
    } else {
      // handle the errors
    }
  }

  public formatTime(date: Date | string | undefined): string {
    return this.messageService.getFormattedTime(date);
  }

  canMarkAsUnread() {
    return (
      this.thread?.messages.length == 0 ||
      this.thread?.messages.filter((x) => isSameAccountToken(x.recipientToken, this.accountToken)).length == 0
    );
  }

  public handleMarkThreadAsUnread() {
    this.markThreadAsUnread.emit(this.thread!);
  }

  public handleArchiveThread() {
    this.archiveThread.emit(this.thread!);
  }
}
